import { useParams } from "react-router";

import type { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

type ReturnType = {
	hotelID: string | undefined;
};

export const useConfirmParams = (): ReturnType => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.SELECT_HOTEL_TEMPLATE>>();

	return {
		hotelID,
	};
};
